import { Langs } from './local';

type LocalNames = {
  nameRu?: string | null;
  nameEn?: string | null;
  nameHy?: string | null;
};

export const getNameLocal = (lang: Langs, localNames: LocalNames = {}) => {
  const title = {
    ru: localNames?.nameRu,
    en: localNames?.nameEn,
    hy: localNames?.nameHy,
  };

  return title[lang] || localNames?.nameRu || 'lang_unknown';
};

type LocalDescr = {
  descrRu?: string | null;
  descrEn?: string | null;
  descrHy?: string | null;
};
export const getDescrLocal = (lang: Langs, localNames: LocalDescr = {}) => {
  const title = {
    ru: localNames?.descrRu,
    en: localNames?.descrEn,
    hy: localNames?.descrHy,
  };

  const result = title[lang];

  if (result === '') return result;

  return result || localNames?.descrRu || 'lang_unknown';
};
